import React, { CSSProperties, useEffect, useRef } from "react";
import lottie from "lottie-web";

interface LottieAnimationProps {
  animationData: any;
  style?: CSSProperties;
}

const LottieAnimation = ({ animationData, style }: LottieAnimationProps) => {
  const lottieRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!lottieRef.current) return;
    const animation = lottie.loadAnimation({
      container: lottieRef.current,
      renderer: "svg",
      autoplay: true,
      animationData,
    });
    return () => animation.destroy();
  }, [animationData]);

  return <div ref={lottieRef} style={style} />;
};

export default LottieAnimation;
